export enum PayoutReason {
    REQUESTED_BY_USER = 1,
    MISSED_ROUND = 2,
    RUN_ENDED = 3,
    CHOICE_LOST = 4,
}
